module.exports = __webpack_public_path__ + "img/6.6c23f1dd.jpg";